import { Link } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import { Bars2Icon } from "@heroicons/react/24/outline";

const ExerciseCard = (props) => {
  const numberOfSets = props.sets.length;

  let setDetails = `${numberOfSets} sets`;

  if (numberOfSets) setDetails = setDetails + `\xa0\xa0|\xa0\xa0`;

  props.sets.forEach((set) => {
    setDetails =
      setDetails +
      ` ${!set.weight ? 0 : set.weight}x${!set.reps ? 0 : set.reps}\xa0\xa0`;
  });

  return (
    <div className={`relative ${props.className}`}>
      <Link
        to={`exercise/${props._id}`}
        type="button"
        className="h-[60px] flex w-full bg-white rounded-md shadow-sm border border-gray-300"
      >
        <div className="h-full bg-gray-300 rounded-l-sm flex items-center p-2">
          <Bars2Icon className="h-5 text-gray-900" />
        </div>
        <div className="p-2 overflow-hidden pr-7">
          <h3 className="text-base font-medium text-gray-900 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {props.name || "Untitled Exercise"}
          </h3>
          <p className="text-sm text-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {setDetails}
          </p>
        </div>
      </Link>
      <div className="absolute top-0 right-0">
        <DropdownMenu
          parentId={props._id}
          menuItems={["Delete"]}
          onDeleteClicked={props.onDeleteExercise}
        />
      </div>
    </div>
  );
};

export default ExerciseCard;
